import { TypeOrNull } from 'models/Common'
import { differenceInMinutes } from 'date-fns'
import { SHIFT_TYPE } from 'models/Shift'
import { TShiftLengthCheckerError } from '../ShiftEditDuplicate/utils/types'
import { calculateEndDateFomStartDateAndHours } from '../ShiftEditDuplicate/utils'

export const calculateShiftDurationHours = (
  dateStart: string,
  hourStart: string,
  hourEnd: string
) => {
  const endDate = calculateEndDateFomStartDateAndHours(dateStart, hourStart, hourEnd)

  const endDateTime = new Date(`${endDate}  ${hourEnd}`)
  const startDateTime = new Date(`${dateStart}  ${hourStart}`)
  const shiftMinutesLength = differenceInMinutes(endDateTime, startDateTime)
  const shiftHoursLength = shiftMinutesLength / 60

  return shiftHoursLength
}

/**
 * Function that checks if the Shift's length is valid
 * @param shift Array of single day shifts or a single multiday shift pbject
 */
export const shiftLengthChecker = (shift: any): TypeOrNull<TShiftLengthCheckerError> => {
  let shiftLengthError: TypeOrNull<TShiftLengthCheckerError> = null

  // When the shift is Single Day, the shift param will be an array (it can be of multiple shift objects, but they all have the same start and end time)
  if (Array.isArray(shift)) {
    if (Number(shift[0].type) === SHIFT_TYPE.SINGLEDAY) {
      for (let i = 0; i < shift.length; i++) {
        const { date_start, hour_start, hour_end } = shift[i]
        const shiftHoursLength = calculateShiftDurationHours(
          date_start.toString(),
          hour_start,
          hour_end
        )

        if (shiftHoursLength > 15) {
          shiftLengthError = {
            message: 'Cannot post shift over 15 hours',
            day_id: shift[i].date_start,
          }
          break
        }

        if (shiftHoursLength === 0) {
          shiftLengthError = {
            message: 'Cannot post shift with the same Start and End Time',
            day_id: shift[i].date_start,
          }
          break
        }
      }
    }
  } else if (Number(shift.type) === SHIFT_TYPE.MULTIDAY) {
    const shiftDays = shift.days

    for (let i = 0; i < shiftDays.length; i++) {
      const { date_start, hour_start, hour_end, id } = shiftDays[i]
      const dayHoursLength = calculateShiftDurationHours(date_start, hour_start, hour_end)

      if (dayHoursLength > 15) {
        shiftLengthError = { message: 'Cannot post shift over 15 hours', day_id: id }
        break
      }

      if (dayHoursLength === 0) {
        shiftLengthError = {
          message: 'Cannot post shift with the same Start and End Time',
          day_id: id,
        }
        break
      }
    }
  }

  return shiftLengthError
}
